import React, { useRef } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../components/loader/DefaultLoader';
import SituationBatterRecord from './sub/SituationBatterRecord';
import TotalBatterRecord from './sub/TotalBatterRecord';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import TotalFuturesBatterRecord from './sub/TotalFuturesBatterRecord';
import SituationFuturesBatterRecord from './sub/SituationFuturesBatterRecord';

function BatterRecordTableMain({profile}) {
    const { t } = useTranslation();

    let totalRef = useRef();
    let situationRef = useRef();
    let totalRecord = useRef();
    let situationRecord = useRef();
    let location = useLocation();
    let locationSplit = location['pathname'].split('/');
    let leagueType = locationSplit[1];

    function recordTypeBtnHandler(e) {
        let btnId = e.target.id;

        if(btnId === 'totalRecord') {
            totalRef.current.classList.add('on');
            situationRef.current.classList.remove('on');

            totalRecord.current.style.display = 'block';
            situationRecord.current.style.display = 'none';
        } else {
            totalRef.current.classList.remove('on');
            situationRef.current.classList.add('on');

            totalRecord.current.style.display = 'none';
            situationRecord.current.style.display = 'block';
        }
    }

    return (
        <>
        <div id="tableTabBox">
            <div className="tab1 on" 
            onClick={recordTypeBtnHandler} id="totalRecord" ref={totalRef}>
                {t('standard')}
            </div>
            <div className="tab2"
            onClick={recordTypeBtnHandler} id="situationRecord" ref={situationRef}>
                {t('splits')}
            </div>
        </div>
        {
            leagueType === 'major'
            ? 
            <>  
            <div style={{display:'block'}} ref={totalRecord}>
                <TotalBatterRecord profile={profile}/>
            </div>
            <div style={{display:'none', position: 'relative'}} ref={situationRecord}>
                <SituationBatterRecord profile={profile}/>
            </div>
            </>
            :
            <>
            <div style={{display:'block'}} ref={totalRecord}>
                <TotalFuturesBatterRecord profile={profile}/>
            </div>
            <div style={{display:'none', position: 'relative'}} ref={situationRecord}>
                <SituationFuturesBatterRecord profile={profile}/>
            </div>
            </>
        }
        </>
    )
}

export default BatterRecordTableMain;